// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1mDig","unreadBadge":"styles_unreadBadge__ZMNw9","modalContent":"styles_modalContent__3K1au","modal":"styles_modal__3rlm-"};